

























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Federation as FederationEnum, Reward } from "@gaia-project/engine";
import { federationRewards } from "@gaia-project/engine/src/tiles/federations";

@Component
export default class FederationTile extends Vue {
  @Prop()
  federation: FederationEnum;

  @Prop()
  used: boolean;

  @Prop({ default: "" })
  filter: string;

  @Prop()
  numTiles: number;

  get rewards(): Reward[] {
    return federationRewards(this.federation);
  }

  get disabled() {
    return this.used || this.federation === FederationEnum.Fed1;
  }
}
